import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={41.625}
      height={104.068}
      viewBox="0 0 41.625 104.068"
      {...props}
    >
      <g data-name="020-lamp-19">
        <path
          data-name="Path 2079"
          d="M20.812 19.079v32.955h8.672V10.406a8.672 8.672 0 10-17.345 0v41.628h8.672zm0 0"
          fill="#ffd200"
        />
        <g data-name="Group 172" fill="#003586">
          <path
            data-name="Path 2080"
            d="M29.484 52.034H1.737l3.469 20.814h31.22l3.465-20.814zm0 0"
          />
          <path
            data-name="Path 2081"
            d="M12.144 72.848h17.341v6.938H12.144zm0 0"
          />
          <path
            data-name="Path 2082"
            d="M12.144 86.724h17.341v6.938H12.144zm0 0"
          />
          <path
            data-name="Path 2083"
            d="M12.144 79.786h17.341v6.938H12.144zm0 0"
          />
        </g>
        <path
          data-name="Path 2084"
          d="M8.675 52.034h24.279v20.814H8.675zm0 0"
          fill="#003586"
        />
        <path
          data-name="Path 2085"
          d="M12.144 52.034h17.341v20.814H12.144zm0 0"
          fill="#165a9f"
        />
        <path
          data-name="Path 2086"
          d="M19.078 13.876h3.469a3.469 3.469 0 013.466 3.469v34.689h-10.4V17.345a3.469 3.469 0 013.465-3.469zm0 0"
          fill="#fee543"
        />
        <path
          data-name="Path 2087"
          d="M20.812 102.334a8.673 8.673 0 008.673-8.672H12.144a8.673 8.673 0 008.668 8.672zm0 0"
          fill="#165a9f"
        />
        <path
          data-name="Path 2088"
          d="M41.215 50.914a1.734 1.734 0 00-1.324-.614h-1.734V13.876a1.734 1.734 0 10-3.469 0V50.3h-3.469V10.407a10.407 10.407 0 10-20.814 0V50.3H6.937V13.876a1.734 1.734 0 10-3.469 0V50.3H1.733a1.734 1.734 0 00-1.71 2.019l3.469 20.813a1.734 1.734 0 001.71 1.45h5.2v19.08a10.407 10.407 0 1020.814 0v-19.08h5.2a1.734 1.734 0 001.71-1.45l3.473-20.813a1.735 1.735 0 00-.384-1.405zm-27.34-40.507a6.938 6.938 0 1113.876 0V50.3h-3.418l.761-.4a1.735 1.735 0 000-3.067L21.057 44.7l4.034-2.13a1.734 1.734 0 000-3.068l-4.032-2.13 4.032-2.128a1.734 1.734 0 000-3.068l-4.024-2.126 4.024-2.118a1.734 1.734 0 000-3.07l-4.029-2.125 4.029-2.123a1.735 1.735 0 10-1.619-3.069L16.534 21.2a1.734 1.734 0 000 3.068l4.027 2.122-4.025 2.12a1.734 1.734 0 000 3.07l4.027 2.125-4.029 2.125a1.734 1.734 0 000 3.07l4.032 2.128-4.032 2.132a1.734 1.734 0 000 3.067l4.039 2.138-3.66 1.935h-3.038zm0 81.52v-3.469H27.75v3.469zm13.876-6.938H13.875V81.52H27.75zM20.813 100.6a6.938 6.938 0 01-6.691-5.2h13.377a6.938 6.938 0 01-6.691 5.2zm6.938-22.548H13.875v-3.47H27.75zm7.2-6.938H6.672l-2.89-17.345h34.061zm0 0"
          fill="#231f20"
        />
      </g>
    </svg>
  )
}

export default SvgComponent
